import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'react-datetime-picker/dist/DateTimePicker.css';
import 'react-calendar/dist/Calendar.css';
import 'react-clock/dist/Clock.css';
import './App.css';
import LoginPage from './pages/LoginPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import DashboardLayout from './layouts/DashboardLayout';
import UserManagement from './pages/UserManagement';
import CompanyManagement from './pages/CompanyManagement';
import ContestManagement from './pages/ContestManagement';
import JobManagement from './pages/JobManagement';
import SubcategoryManagement from './pages/SubcategoryManagement';
import MiddleCategoryManagement from './pages/MiddleCategoryManagement';
import ProfileSettings from './pages/ProfileSettings';
import { ProtectedRoute } from './components';

function App() {
  return (
    <Router>
      <ToastContainer position="top-right" autoClose={3000} />
      <Routes>
        <Route path="/" element={<Navigate to="/administrator/login" replace />} />
        <Route path="/login" element={<Navigate to="/administrator/login" replace />} />
        <Route path="/administrator/login" element={<LoginPage />} />
        <Route path="/resetpassword" element={<ResetPasswordPage />} />
        <Route path="/administrator/reset-password" element={<ResetPasswordPage />} />
        <Route path="/administrator" element={<ProtectedRoute><DashboardLayout /></ProtectedRoute>}>
          <Route index element={<Navigate to="/administrator/users" replace />} />
          <Route path="users" element={<UserManagement />} />
          <Route path="companies" element={<CompanyManagement />} />
          <Route path="contests" element={<ContestManagement />} />
          <Route path="jobs" element={<JobManagement />} />
          <Route path="subcategories" element={<SubcategoryManagement />} />
          <Route path="middlecategories" element={<MiddleCategoryManagement />} />
          <Route path="profile" element={<ProfileSettings />} />
        </Route>
        <Route path="*" element={<Navigate to="/administrator/login" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
